interface quicklinks {
  id: number;
  title: string;
  link: string;
  requiresIPD?: boolean;
}

export const buildHeaderMenu = (isIPDEnabled: boolean): quicklinks[] => {
  const menus: quicklinks[] = [
    { id: 1, title: 'LABEL.DASHBOARD', link: '/dashboard' },
    { id: 2, title: 'ENTITY.PATIENT', link: '/patient' },
    { id: 3, title: 'ENTITY.APPOINTMENT', link: '/appointment' },
  ];

  if (isIPDEnabled) {
    menus.push({
      id: 4,
      title: 'ENTITY.IPD',
      link: '/ipd/management',
    });
  }

  menus.push({
    id: 5,
    title: 'ENTITY.PHARMACY',
    link: '/pharmacy',
  });

  return menus;
};
